import { render, staticRenderFns } from "./DealShow.vue?vue&type=template&id=43276522&scoped=true&"
import script from "./DealShow.vue?vue&type=script&lang=js&"
export * from "./DealShow.vue?vue&type=script&lang=js&"
import style0 from "./DealShow.vue?vue&type=style&index=0&id=43276522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43276522",
  null
  
)

export default component.exports